var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"vue-link",style:(_vm.computedStyle),attrs:{"to":_vm.href}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }